export const StepWizardArrowIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 32 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_4798_2111)">
      <path d="M0.5 1L30.5 38L0.5 75" stroke="#E4E7EC" />
    </g>
    <defs>
      <clipPath id="clip0_4798_2111">
        <rect width="31" height="76" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
